import type { CmsApiAnchorBlockData } from '#/modules/cms/api/types/blocks/CmsApiAnchorBlock';

type Props = {
  data: CmsApiAnchorBlockData;
};

export function CmsAnchorBlock({ data: { anchor } }: Props) {
  return (
    // oxlint-disable-next-line jsx-a11y/anchor-has-content jsx-a11y/anchor-is-valid
    <a
      id={anchor}
      data-qa-id={`anchor-block-${anchor}`}
      className="anchor-block"
    />
  );
}
